import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Coins, Heart, Package, Settings, Users, type LucideIconData } from 'lucide-angular';

import { IconComponent } from '../../../../shared/ui/icon/icon.component';
import { PROFILE_COPY } from '../../profile.copy';

interface ProfileTabLink {
  /** Ruta hija de `/perfil` (relativa al contenedor). */
  path: string;
  label: string;
  icon: LucideIconData;
}

/**
 * Pestañas de `/perfil` en su orden (B10 W0a). El `PROFILE_TABS` del modelo viejo (ids en inglés y «Wishlist», B30)
 * se borró con W2.
 */
const PROFILE_TAB_LINKS: readonly ProfileTabLink[] = [
  { path: 'pedidos', label: PROFILE_COPY.TABS.ORDERS, icon: Package },
  { path: 'coins', label: PROFILE_COPY.TABS.COINS, icon: Coins },
  { path: 'deseos', label: PROFILE_COPY.TABS.WISHLIST, icon: Heart },
  { path: 'ajustes', label: PROFILE_COPY.TABS.SETTINGS, icon: Settings },
  { path: 'comunidad', label: PROFILE_COPY.TABS.COMMUNITY, icon: Users },
];

/**
 * Barra de pestañas del perfil: enlaces del router, sin estado propio. La pestaña activa la marca
 * `routerLinkActive` (clase + `aria-current="page"`), también en `pedidos/:id`.
 */
@Component({
  selector: 'app-profile-tabs',
  imports: [IconComponent, RouterLink, RouterLinkActive],
  templateUrl: './profile-tabs.component.html',
  styleUrl: './profile-tabs.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class ProfileTabsComponent {
  protected readonly tabs = PROFILE_TAB_LINKS;
  protected readonly navLabel = PROFILE_COPY.TABS_NAV_LABEL;
}
